import Vue from 'vue';
import router from './router/index.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import fly from './http';
import store from './store';
import VCharts from 'v-charts';
import App from './App.vue';

Vue.use(VCharts);
Vue.use(ElementUI);
Vue.config.productionTip = false;

Vue.prototype.$fly = fly;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')